import React from 'react';
import {Box, Stack} from "@mui/material";
import {useTheme} from "@mui/material/styles";
import LabelledMuiTypography from "../../../../../ui/mui/mui-display-data/LabelledMuiTypography";
import useApiGetSchedaCostoDetail from "./api-hooks/useApiGetSchedaCostoDetail";
import MotionDivider from "../../../../../ui/MotionDivider";

interface Props {
    order_id?: number,
}

const SchedaCostoVociCard = ({order_id: order_id}: Props) => {
    const theme = useTheme();
    const fontSize = 18;

    const {data: detailedObj, isSuccess, isFetched} = useApiGetSchedaCostoDetail(order_id);

    return (
        <Box component="fieldset" sx={{
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'flex-end',
            border: '1px solid lightgrey',
            borderRadius: '4px',
            padding: '10px',
            backgroundColor: theme.palette.backgroundAppGarageColor.main
        }}>
            <legend style={{
                padding: '0 8px',
                color: theme.palette.primary.main,
                fontWeight: 500
            }}>
                Lavorazioni/Costi inseriti manualmente
            </legend>

            {detailedObj?.voci && detailedObj.voci.length > 0 ? (
                <Stack spacing={1} width="100%">
                    {detailedObj.voci.map((voce, index) => (
                        <Box key={voce.id}>
                            <LabelledMuiTypography
                                label={'Lavorazione/Costo'}
                                value={voce.voce_scheda_costo.name}
                                upperCaseValue={false}
                                fontSize={fontSize}
                            />
                            <LabelledMuiTypography
                                label={'Costo unitario'}
                                value={`${voce.value?.toFixed(2)} € al ${voce.voce_scheda_costo.um_coefficient}`}
                                upperCaseValue={false}
                                fontSize={fontSize}
                            />
                            <LabelledMuiTypography
                                label={'Costo Totale'}
                                value={`${voce.calculated_value?.toFixed(2)} €`}
                                upperCaseValue={false}
                                fontSize={fontSize}
                            />

                            {index < detailedObj.voci.length - 1 && <MotionDivider/>}
                        </Box>
                    ))}
                </Stack>
            ) : (
                <LabelledMuiTypography
                    label={'Nessun costo inserito'}
                    value={''}
                    upperCaseValue={false}
                    fontSize={fontSize}
                />
            )}
        </Box>
    );
}

export default SchedaCostoVociCard;